import React from "react";
import { useHistory } from "react-router";
import { updatePassword } from "../../APIs/PostAPIS";
import { MainContext } from "../Dashboard/DashboardContext/Context";
import DashboardFooter from "../Dashboard/DashboardFooter/DashboardFooter";
import LandingHeader from "../LandingPage/LandingHeader/LandingHeader";
import Notification from "../Portals/Notification/Notification";
import "./reset-password.style.scss";
export default function ResetPassword({ modal = false, closeIt }) {
  const history = useHistory();
  const [displayPassword, setDisplayPassword] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const context = React.useContext(MainContext);
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });

  const { userType } = context;
  const [handleDetails, setHandleDetails] = React.useState({
    password: "",
    cPassword: "",
    oldPassword: "",
  });
  const checkError = () => {
    if (
      handleDetails.password &&
      handleDetails.cPassword !== handleDetails.password
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleSubmit = async () => {
    setLoading(true);
    let temp = {
      email: localStorage.getItem("userEmail"),
      role_type: userType,
      password: handleDetails.password,

      oldpassword: handleDetails.oldPassword,
    };
    try {
      let res = await updatePassword({ ...temp });
      setLoading(false);
      if (res.data?.data) {
        setNotification({
          status: true,
          title: "Your password is updated",
          moreDetails: "",
        });
        let a = setTimeout(() => {
          if (modal) {
            closeIt();
          } else {
            history.push("/user/profile");
          }
          clearTimeout(a);
        }, 2000);
      } else {
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: "",
        });
        let a = setTimeout(() => {
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          });
          clearTimeout(a);
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      setNotification({
        status: true,
        title: "Something went wrong",
        moreDetails: "",
      });
      let a = setTimeout(() => {
        setNotification({
          status: false,
          title: "",
          moreDetails: "",
        });
        clearTimeout(a);
      }, 2000);
    }

    setLoading(false);
  };
  return (
    <div className="reset-password-main">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      {modal ? "" : <LandingHeader />}
      <section className="reset-password-body">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            checkError() ? setError(true) : handleSubmit();
          }}
        >
          <h4>{modal ? "Change Password" : "Reset Account Password"}</h4>

          <div className="on-border-input">
            <span>Old password</span>
            <input
              autoComplete="new-password"
              type={displayPassword ? "text" : "password"}
              placeholder=""
              type={displayPassword ? "text" : "password"}
              value={handleDetails.oldPassword}
              onChange={(e) =>
                setHandleDetails({
                  ...handleDetails,
                  oldPassword: e.target.value,
                })
              }
              required
            />
          </div>
          <div className="on-border-input">
            <span>New password</span>
            <input
              autoComplete="new-password"
              type={displayPassword ? "text" : "password"}
              placeholder=""
              type={displayPassword ? "text" : "password"}
              value={handleDetails.password}
              onChange={(e) =>
                setHandleDetails({ ...handleDetails, password: e.target.value })
              }
              required
            />
          </div>
          <div
            className={`on-border-input ${error ? "error-input" : ""} ${
              handleDetails.password &&
              handleDetails.password === handleDetails.cPassword
                ? "correct"
                : ""
            }`}
          >
            <span>Confirm password</span>
            <input
              autoComplete="new-password"
              name="cPassword"
              placeholder=""
              type={displayPassword ? "text" : "password"}
              required
              value={handleDetails.cPassword}
              onChange={(e) => {
                setError(false);
                setHandleDetails({
                  ...handleDetails,
                  cPassword: e.target.value,
                });
              }}
            />
            <p>
              {handleDetails.password &&
              handleDetails.password === handleDetails.cPassword
                ? "Matched"
                : "Unmatched"}{" "}
              Password
            </p>
          </div>
          <div className="check-wrapper">
            <input
              onChange={(e) => setDisplayPassword(e.target.checked)}
              checked={displayPassword}
              type="checkbox"
            />
            <span>Show Password</span>
          </div>
          <div className="submit-button-wrapper">
            <button
              disabled={
                handleDetails.password &&
                handleDetails.password !== handleDetails.cPassword
              }
              // onClick={() => (checkError() ? setError(true) : handleSubmit())}
              className="submit-button"
            >
              {loading ? "Updating...." : "Update"}
            </button>
          </div>
        </form>
      </section>

      {modal ? "" : <DashboardFooter />}
    </div>
  );
}
